import React, { useState, useEffect } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import './InvAlarmas.css';

function InvAlarmas(props) {
    var getBrowserWidth = function () {

        if (window.innerWidth < 1023) {
            return "xs";
        }

    };
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const { code, ct, inv } = props;
    /*const params = useParams();
    const { ct, inv } = params;*/

    const [filtrarActivas, setFiltrarActivas] = useState(false);
    var [textoBotonActivas, setTextoBotonActivas] = useState('Mostrar solo activas');

    var [INV, setINV] = useState([]);
    var [activas, setActivas] = useState(0);
    var [filas, setFilas] = useState([]);
    const variablesAPedir = "id,name,alarmId,severity,active,description,startDate,endDate";

    let number = 0;

    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/logs/inverters?idSolarFarm=" + idParque + "&idCT=" + ct + "&idInverter=" + inv + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
            .then(async (dataINV) => { setINV(await dataINV.json()); })
            .catch(e => { console.log(e); })
        sessionStorage.setItem("ct", ct);
        sessionStorage.setItem("inv", inv);
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key") && ct == sessionStorage.getItem("ct") && inv == sessionStorage.getItem("inv")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/logs/inverters?idSolarFarm=" + idParque + "&idCT=" + ct + "&idInverter=" + inv + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
                    .then(async (dataINV) => { setINV(await dataINV.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number, ct, inv]);

    function botonFiltrarActivas() {
        if (textoBotonActivas === 'Mostrar solo activas') {
            setTextoBotonActivas('Mostrar todo');
            setFiltrarActivas(true);
        } else {
            setTextoBotonActivas('Mostrar solo activas');
            setFiltrarActivas(false);
        }
    };

    /*Tamaño para las columnas de la tabla y cuatas filas de alarmas queremos*/
    var anchoPantalla, columnasTabla, ocupadoPorcentaje, pixelesOcupados, pixelesRestantes, tamañoColum, tamColumPeque, tamañoDescri, tamañoFechas;
    var filas_alarmas;

    if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
        /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
        anchoPantalla = window.screen.width;
        columnasTabla = 7;
        ocupadoPorcentaje = 30;
        pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
        pixelesRestantes = anchoPantalla - pixelesOcupados;
        tamañoColum = (pixelesRestantes / columnasTabla) - 1.1;
        tamColumPeque = tamañoColum / 2;
        tamañoDescri = tamañoColum + (tamColumPeque * 3);
        tamañoFechas = tamañoColum + (tamColumPeque / 2);
        filas_alarmas = 12;
    } else {
        /*Tamaño para las columnas de la tabla, si es en movil o tablet*/
        tamañoColum = 100;
        tamColumPeque = 90;
        tamañoDescri = 320;
        tamañoFechas = 160;
        filas_alarmas = 7;
    }

    /**Controlar el reajuste de tamaño de pantalla */
    window.addEventListener("resize", () => {
        if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
            /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
            anchoPantalla = window.screen.width;
            columnasTabla = 7;
            ocupadoPorcentaje = 30;
            pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
            pixelesRestantes = anchoPantalla - pixelesOcupados;
            tamañoColum = (pixelesRestantes / columnasTabla) - 1.1;
            tamColumPeque = tamañoColum / 2;
            tamañoDescri = tamañoColum + (tamColumPeque * 2);
            tamañoFechas = tamañoColum + (tamColumPeque / 2);
            filas_alarmas = 12;
        } else {
            /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
            tamañoColum = 100;
            tamColumPeque = 90;
            tamañoDescri = 320;
            tamañoFechas = 160;
            filas_alarmas = 7;
        }
    });

    const columnas = [{ field: 'id', headerName: 'ID', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', hide: true, cellClassName: 'cell-invAlarma-id' },
    { field: "dispositivo", headerName: "Dispositivo", width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-invAlarma-dispositivo' },
    { field: 'alarma', headerName: 'Alarma', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-invAlarma' },
    { field: 'severidad', headerName: 'Severidad', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-invAlarma-severidad' },
    { field: 'descripcion', headerName: 'Descripción', width: tamañoDescri, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-invAlarma-descripcion' },
    { field: 'estado', headerName: 'Estado', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-invAlarma-estado' },
    { field: 'inicio', headerName: 'Fecha Inicio', width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-invAlarma-inicio' },
    { field: 'fin', headerName: 'Fecha Fin', width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-invAlarma-fin' }];

    /*Mapeado de las alarmas */
    useEffect(() => {
        var array = [];
        var activas_aux = 0;
        INV.map((datoINV) => {
            const { id, name, alarmId, severity, active, description, startDate, endDate } = datoINV;
            var auxState;
            if (active === true) { //Cambiar el true por activa y el false por inactiva
                auxState = "Activa";
                activas_aux++;
            } else {
                auxState = "Inactiva";
            }
            array.push({ id: id, dispositivo: name, alarma: alarmId, severidad: severity, descripcion: description, estado: auxState, inicio: startDate, fin: endDate });
        })

        if (filtrarActivas === true) {
            array = array.filter(a => { return a.estado === "Activa" });
        }

        setFilas(array.reverse()); //Queremos que las mas nuevas aparezcan antes
        setActivas(activas_aux);
    }, [INV, filtrarActivas]);

    var mobil = getBrowserWidth();
    if (mobil === 'xs') {
        return (
            <div className='container-fluid' style={{ marginTop: '15px' }}>
                <div className='row'>
                    <div className='col'>
                        <div className='row'>
                            <div className='col-auto'>
                                <h5>Alarmas</h5>
                            </div>
                            <div className='col-auto'>
                                Activas: <strong>{activas}</strong>
                            </div>
                            <div className='col-auto'>
                                <a id='active-inv-alarms-button' onClick={botonFiltrarActivas}>{textoBotonActivas}</a>
                            </div>
                            <div className='row' style={{ margin: 0, padding: 0 }}>
                                <div className='col' id='div-table-alarms-inv'>
                                    <DataGridPro sx={{
                                        width: '100%',
                                        align: 'center',
                                        ".MuiDataGrid-columnHeaders": { overflowX: 'scroll' },
                                        ".MuiDataGrid-row": { display: 'block', width: '100%', paddingLeft: '5%', marginLeft: '0%' },
                                        ".MuiDataGrid-virtualScrollerContent": { width: 'auto !important' },
                                        ".MuiDataGrid-virtualScrollerRenderZone": { width: ' -webkit-fill-available' },
                                        ".MuiDataGrid-main": { overflow: 'none', },
                                        ".MuiDataGrid-virtualScroller": { marginTop: '56px !important' },
                                        ".MuiDataGrid-cell": { width: 'fit-content', border: 'none', position: 'relative', paddingLeft: '50%', marginTop: '.5%' },
                                        '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' },
                                        '& .super-app-theme--Activa': { color: 'red' },
                                        '& .super-app-theme--Inactiva': { color: 'green', }
                                    }}
                                        rows={filas} columns={columnas} pagination pageSize={5} autoHeight={true} /*checkboxSelection*/
                                        componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "Alarmas" } } }}
                                        components={{Toolbar: GridToolbarExport}} disableSelectionOnClick disableColumnResize='true'
                                        getRowHeight={() => 'auto'}
                                        getRowClassName={(params) => `super-app-theme--${params.row.estado}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className='container-fluid' style={{ marginTop: '15px' }}>
                <div className='row'>
                    <div className='col'>
                        <div className='row'>
                            <div className='col-auto'>
                                <h5>Alarmas</h5>
                            </div>
                            <div className='col-auto'>
                                Activas: <strong>{activas}</strong>
                            </div>
                            <div className='col-auto'>
                                <a id='active-inv-alarms-button' onClick={botonFiltrarActivas}>{textoBotonActivas}</a>
                            </div>
                            <div className='row' style={{ margin: 0, padding: 0 }}>
                                <div className='col' id='div-table-alarms-inv'>
                                    <DataGridPro sx={{
                                        width: '100%',
                                        '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' },
                                        '& .super-app-theme--Activa': { color: 'red' },
                                        '& .super-app-theme--Inactiva': { color: 'green', }
                                    }}
                                        rows={filas} columns={columnas} pagination pageSize={12} autoHeight={true}
                                        components={{ Toolbar: GridToolbarExport }} disableSelectionOnClick
                                        componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "AlarmasINV" + ct + "-" + inv } } }}
                                        getRowClassName={(params) => `super-app-theme--${params.row.estado}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
};

export default InvAlarmas;